import * as React from 'react'
import { GridColDef } from '@mui/x-data-grid-pro'

import type { ActivitySummaryRow } from '../../typings'
import { dateTimeValueFormatter } from '@user/components/xGrid'
import { ActionMenu, RelatedToCell, SubjectCell } from './cellRenderers'

export const columns = (): GridColDef<ActivitySummaryRow>[] => {
  return [
    {
      width: 50,
      type: 'actions',
      field: 'actions',
      resizable: false,
      renderCell: (params) => <ActionMenu {...params} />,
    },
    {
      width: 150,
      field: 'subject',
      headerName: 'Subject',
      renderCell: (params) => <SubjectCell {...params} />,
    },
    {
      headerName: 'Type',
      field: 'activityType',
    },
    {
      field: 'owner',
      headerName: 'Owner',
      valueGetter: ({ row }) => row,
      valueFormatter: ({ value }) =>
        value.owner === null
          ? 'Unassigned'
          : value.owner + (value.ownerIsActive === false ? ' (Inactive)' : ''),
    },
    {
      width: 165,
      type: 'dateTime_12',
      field: 'createdDate',
      headerName: 'Date Created',
      valueFormatter: dateTimeValueFormatter,
    },
    {
      width: 165,
      type: 'dateTime_12',
      field: 'startDate',
      headerName: 'Start Date',
      valueFormatter: dateTimeValueFormatter,
    },
    {
      width: 165,
      type: 'dateTime_12',
      field: 'dueDate',
      headerName: 'Due Date',
      valueFormatter: dateTimeValueFormatter,
    },
    {
      field: 'description',
      headerName: 'Description',
    },
    {
      field: 'relatedTo',
      headerName: 'Related To',
      renderCell: (params) => <RelatedToCell {...params} />,
    },
  ]
}
